// 極簡日誌抽象 — 對應 Unity LogUtils。集中管理輸出層級，避免散落的 console 呼叫。
// 之後可在此接上遠端錯誤回報（對應框架 ErrorLogEvent）。

export const LogLevel = {
  Debug: 0,
  Info: 1,
  Warn: 2,
  Error: 3,
  Silent: 4,
} as const
export type LogLevelValue = (typeof LogLevel)[keyof typeof LogLevel]

const PREFIX = '[FaFaCat]'

class Logger {
  private level: LogLevelValue = import.meta.env.DEV ? LogLevel.Debug : LogLevel.Warn

  setLevel(level: LogLevelValue): void {
    this.level = level
  }

  debug(...args: unknown[]): void {
    if (this.level <= LogLevel.Debug) console.debug(PREFIX, ...args)
  }

  info(...args: unknown[]): void {
    if (this.level <= LogLevel.Info) console.info(PREFIX, ...args)
  }

  warn(...args: unknown[]): void {
    if (this.level <= LogLevel.Warn) console.warn(PREFIX, ...args)
  }

  error(...args: unknown[]): void {
    if (this.level <= LogLevel.Error) console.error(PREFIX, ...args)
  }
}

export const logger = new Logger()
